// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__82qAT","page-btn":"Pagination_page-btn__l6Zs7"};